import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	findMaxInNumberArray,
	findMinInNumberArray,
	isDeepEqualComplex,
	isNonEmptyArray,
} from "../../../../../common/utils";
import { useApi, usePrevious } from "../../../../../common/hooks";
import { QuickAccessService } from "../../../../../api";
import { generateFilters } from "../../../../../common/components";
import { setQuickAccessResults } from "../../../slice/document/document-slice";

export default function FilterEffect({ restrictedContent }) {
	const [isLoadingQuickAccessSearch, setIsLoadingQuickAccessSearch] = useState(false);
	const documentId = useSelector(({ srDocument }) => srDocument.documentId);
	const currentPage = useSelector(({ srPdf }) => srPdf.page + 1);
	const quickAccessResults = useSelector(({ srDocument }) => srDocument.quickAccessResults);
	const numberOfPages = useSelector(({ srDocument }) => srDocument.numberOfPages);
	const transverseFilters = useSelector(({ srProjectDocument }) => srProjectDocument.transverseFilters);
	const isThereAnotherTransverseFilter = useSelector(
		({ srProjectDocument }) => srProjectDocument.isThereAnotherTransverseFilter
	);
	const prevTransverseFilters = usePrevious(transverseFilters);
	const prevMetadata = usePrevious(restrictedContent);
	const prevPage = usePrevious(currentPage);
	const prevNumberOfPages = usePrevious(numberOfPages);
	const { call: getSearchResults } = useApi(QuickAccessService.getFilterResultsInDocumentPages);
	const dispatch = useDispatch();
	useEffect(() => {
		if (
			(((!prevNumberOfPages || !isNonEmptyArray(prevMetadata)) && isNonEmptyArray(restrictedContent)) ||
				!isDeepEqualComplex(transverseFilters, prevTransverseFilters) ||
				(prevPage !== currentPage &&
					(!quickAccessResults?.some((pageResult) => pageResult.page === Math.max(1, currentPage - 3)) ||
						!quickAccessResults?.some(
							(pageResult) => pageResult.page === Math.min(currentPage + 3, numberOfPages)
						)))) &&
			isNonEmptyArray(restrictedContent) &&
			numberOfPages !== undefined &&
			!isLoadingQuickAccessSearch &&
			isThereAnotherTransverseFilter
		) {
			setIsLoadingQuickAccessSearch(true);
			const startNumber = Math.max(1, currentPage - 5);
			const endNumber = Math.min(currentPage + 5, numberOfPages);
			const existingPages = quickAccessResults.map((quickResult) => quickResult.page);
			const newStartNumber = findMinInNumberArray(existingPages, startNumber, endNumber);
			const newEndNumber = findMaxInNumberArray(existingPages, startNumber, endNumber);
			if (documentId && newStartNumber && newEndNumber) {
				getSearchResults(
					{ documentId, startNumber: newStartNumber, endNumber: newEndNumber },
					generateFilters(transverseFilters)
				)
					.then((values) => {
						dispatch(
							setQuickAccessResults({
								results: Array.from({ length: newEndNumber - newStartNumber + 1 }, (_, index) => ({
									page: newStartNumber + index,
									values: values?.[newStartNumber + index] || [],
								})),
							})
						);
					})
					.catch(console.error)
					.finally(() => setIsLoadingQuickAccessSearch(false));
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		prevMetadata,
		prevNumberOfPages,
		prevPage,
		numberOfPages,
		restrictedContent,
		quickAccessResults,
		isLoadingQuickAccessSearch,
		documentId,
		transverseFilters,
		currentPage,
		prevTransverseFilters,
	]);

	return <div />;
}
